import { useCallback } from 'react';
import { SheetLarge } from '../property-card/sheet-large';
import { SheetSmall } from '../property-card/sheet-small';

export function Sheet({
  properties,
  setProperties,
}) {
  let close = useCallback(() => setProperties([]), []);

  if (!properties.length) return null;

  let first = properties[0];

  return (
    <div className={`map-search__sheet`}>
      <div className={`map-search__sheet-backdrop`} onClick={close} />

      <div className={`map-search__sheet-content`}>
        <div className={`map-search__sheet-header`}>
          <div className={`map-search__sheet-heading`}>
            {properties.length === 1 ? (
              <>{first.type} {first.status}</>
            ) : (
              <>{properties.length} properties in {first.suburb}</>
            )}
          </div>

          {/* TODO: add close icon */}
          <div className={`map-search__sheet-close`} onClick={close}>x</div>
        </div>

        {properties.length === 1 ? (
          <SheetLarge {...first} />
        ) : (
          properties.map(x => <SheetSmall key={x.id} {...x} />)
        )}
      </div>
    </div>
  );
}

